/*
 * Input directive
 * Version 1.0.0
 * Octave
 * Modified from <ng-input> <http://cesardeazevedo.github.io/ng-input/>.
 **/

(function () {
  'use strict';

  noZoomDirective.$inject = ["$document"];
  angular
    .module('directives.form', [])

    /* @ngInject */
    .directive('rbInput', function () {

      var template = ['<span class="input">',
        '<span class="form-control-feedback error glyphicon glyphicon-exclamation-sign"></span>',
        '<span class="form-control-feedback success glyphicon glyphicon-ok"></span>',
        '<label class="input-label">',
        '<span class="input-label-content"></span>',
        '</label>',
        '</span>'
      ].join('');

      return {
        restrict: 'A',
        /* require: 'ngModel',*/
        priority: 200,
        scope: {
          theme: '@',
          label: '@?',
          icon: '@',
          color: '@',
          ngRequired: '='
          /* ngRequired:  '@valRequired',
          ngPattern:   '@',
          ngMinlength: '=valMinlengthMin',
          ngMaxlength: '=',
          ngChange:    '&ngChange',
          ngTrim:      '=',
          ngModel:     '=',
          trigger : '@focus'*/
        },
        link: function (scope, element, attrs) {

          var $wrapper = angular.element(template);
          element.after($wrapper);
          $wrapper.prepend(element);

          scope.input = element;

          // Default options
          attrs.theme = attrs.theme || 'default';
          attrs.type  = attrs.type  || 'text';
          attrs.color = attrs.color || '1';
          var optRequired = attrs.optRequired === 'true' ? ' opt-required' : '';

          var inputClass = 'input-filled';

          element
            .addClass('form-control input-field input-field-' + attrs.theme)
            .parent().addClass('input-' + attrs.theme + optRequired);

          var $label = element.parent().find('label');
          $label
            .attr('for', attrs.id)
            .addClass('input-label-' + attrs.theme)
            .find('.input-label-content').addClass('input-label-content-' + attrs.theme);

          if (angular.isDefined(attrs.label)) {
            if (attrs.required) {
              scope.label = scope.label + ' <sup>*</sup>';
            }
            $label.find('.input-label-content').html(scope.label);
          }

          if (angular.isDefined(attrs.placeholder)) {
            if (attrs.required) {
              element.attr('placeholder', attrs.placeholder + ' *');
            }
          }

          if (scope.icon && scope.icon !== '') {
            element.addClass('with-icon');
            $label.prepend('<i class="glyphicon ' + scope.icon + '"></i>');
          }

          onInputChange();
          scope.input.on('focus', onInputFocus);
          scope.input.on('blur', onInputBlur);

          // To detect browser autofill
          scope.input.on('change', onInputChange);

          if (angular.isDefined(attrs.ngRequired)) {
            scope.$watch(function () { return scope.ngRequired; }, function (value) {
              if (angular.isDefined(attrs.label)) {
                scope.label = !value ? attrs.label : attrs.label + ' <sup>*</sup>';
                $label.find('.input-label-content').html(scope.label);
              }
            });
          }

          scope.$watch(function () { return scope.input.val(); }, function () {
            onInputChange();
          });

          function onInputChange() {
            if (scope.input.val().trim() !== '') addClass();
          }

          function onInputFocus() {
            addClass();
          }

          function onInputBlur() {
            if (scope.input.val().trim() === '') removeClass();
          }

          function addClass() {
            $wrapper.addClass(inputClass);
          }

          function removeClass() {
            $wrapper.removeClass(inputClass);
          }
        }
      };
    })

    /* @ngInject */
    .directive('ngModelInit', ["$parse", function ($parse) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs) {
          var value = attrs.ngModelInit || attrs.value || element.text();
          value = String(value).toLowerCase() === 'false' ? false : value;
          value = String(value).toLowerCase() === 'true' ? true : value;
          $parse(attrs.ngModel).assign(scope, value);
        }
      };
    }])

    .directive('input', noZoomDirective)
    .directive('textarea', noZoomDirective)
    .directive('select', noZoomDirective);

  /* @ngInject */
  function noZoomDirective($document) {
    var maxScale = ',maximum-scale=';

    var viewport = _.find($document[0].getElementsByTagName('meta'), function (tag) {
      return tag.name === 'viewport';
    });
    var content = viewport.content;

    function changeViewport(event) {
      if (event.type === 'blur') {
        viewport.content = content;
      } else {
        viewport.content = content + maxScale + 1;
      }
    }

    return {
      link: function (scope, element) {
        element.on('focus blur', changeViewport);
      }
    };
  }

})();
